import React from "react";
import { motion } from "framer-motion";

// Viewport settings for better animation triggering
const viewportSettings = {
  once: true,
  amount: 0.1,
  margin: "0px 0px -50px 0px",
};

const TrustedBy = () => {
  const clients = Array.from(
    { length: 12 },
    (_, i) => `/clients/client-${i}.svg`
  );

  return (
    <section className="py-16 bg-white">
      <div className="container-custom">
        <div className="text-center mb-6">
          <p className="text-sm uppercase tracking-wider text-gray-500 font-semibold">
            Trusted by
          </p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-6 items-center justify-items-center opacity-60">
          {clients.map((client, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={viewportSettings}
              transition={{ duration: 0.5, delay: index * 0.05 }}
            >
              <img
                src={client}
                alt={`Client ${index + 1}`}
                className="h-12 w-auto grayscale hover:grayscale-0 transition-all duration-300"
                onError={(e) => {
                  e.target.style.display = "none";
                }}
              />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustedBy;
